{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "Alle opties bekijken",
  "Spoiler_Reveal_Tooltip": "Klik om te onthullen",
  "VerticalEmbed_Event_Error_Subtitle": "This event has been deleted, replace it with another event.",
  "Viewer_Toolbar_Twitter_Tooltip": "Tweet dit",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "Item is samengevouwen",
  "Spoiler_Reveal_Video_CTA": "Video laten zien",
  "VerticalEmbed_Pricing_Plan": "Plan only",
  "Image_Expand_Button_AriaLabel": "Afbeelding uitvouwen",
  "VerticalEmbed_From_Price": "From",
  "Poll_Viewer_ShowAllResults_CTA": "Bekijk alle resultaten",
  "Spoiler_Reveal_Image_Placeholder": "Deze afbeelding bevat een spoiler",
  "VerticalEmbed_Ribbon": "Sale",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Schuifregelaar zoeken",
  "VerticalEmbed_Error_Subtitle": "This item has been deleted, replace it with another item.",
  "Poll_Viewer_Multiselect_Footer": "Je kunt stemmen op meer dan één antwoord.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "Meer audiobediening weergeven",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Failed to load service",
  "Fullscreen_Close_Button_AriaLabel": "Sluiten",
  "VerticalEmbed_Event_Fetch_Error_Title": "Failed to load event",
  "UploadFile_Viewer_Loader": "Bezig met laden {{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "Avatar van gebruiker",
  "Preview_ReadMore_Label": "Meer lezen",
  "Spoiler_Insert_Tooltip": "Spoiler",
  "VerticalEmbed_Product_Fetch_Error_Title": "Failed to load product",
  "Fullscreen_Shrink_Button_AriaLabel": "Shrink",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "Volume",
  "Spoiler_Reveal_Gallery_Placeholder": "Deze galerij bevat een spoiler",
  "Fullscreen_Expand_Button_AriaLabel": "Expand",
  "VerticalEmbed_Bookings_Button": "Nu boeken",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "Dempen opheffen",
  "Spoiler_Reveal_Gallery_CTA": "Galerij laten zien",
  "Poll_Viewer_ShowLess_CTA": "Minder weergeven",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "Dempen",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}} anonieme",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Volgen",
  "VerticalEmbed_Products_Button": "Nu kopen",
  "Poll_Viewer_Toast_Error_ServerDown": "Er kan geen verbinding worden gemaakt met de server. Probeer het later opnieuw.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}} persoon heeft op dit antwoord gestemd",
  "Poll_Viewer_VoteCount": "{{number}} stemmen",
  "VerticalEmbed_Events_Button": "Nu registreren",
  "Spoiler_Reveal_Image_CTA": "Afbeelding laten zien",
  "Poll_Viewer_Toast_Error_Connection": "Geen internet. Controleer je verbinding.",
  "Poll_Viewer_Visibility_Owner_Footer": "Alleen jij kunt de resultaten zien.",
  "VerticalEmbed_Booking_Error_Title": "Service deleted",
  "VerticalEmbed_Product_Error_Title": "Product deleted",
  "VerticalEmbed_Fetch_Error_Subtitle": "Unable to load item information.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "{{count}} mensen hebben op dit antwoord gestemd",
  "VerticalEmbed_Event_Error_Title": "Event deleted",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "Item is uitgevouwen",
  "Audio_Plugin_Cover_Alt": "Audio cover",
  "Spoiler_Reveal_Video_Placeholder": "Deze video bevat een spoiler",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Unable to load product information.",
  "VerticalEmbed_Fetch_Error_Title": "Failed to load item",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "This product has been deleted, replace it with another product.",
  "VerticalEmbed_Booking_Error_Subtitle": "This service has been deleted, replace it with another service.",
  "Preview_SeeFullPost_Label": "Bekijk volledige post",
  "UploadFile_Viewer_Download": "Download {{fileType}}",
  "VerticalEmbed_Units_Hour": "{{uur}}u",
  "VerticalEmbed_Units_Minute": "{{minuten}}min",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Unable to load event information.",
  "VerticalEmbed_Error_Button": "Replace",
  "VerticalEmbed_Error_Title": "Item deleted",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Unable to load service information.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
